import axios from 'axios';

// Split out of SecurityIncidentsModal so App can poll the unread badge on
// load without pulling the (lazy-loaded) modal into the entry bundle.
const API_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? 'http://localhost:5100'
  : (process.env.REACT_APP_API_URL || '');

export async function fetchSecurityIncidentSummary() {
  const response = await axios.get(`${API_URL}/api/security/incidents/summary`, {
    withCredentials: true,
  });
  return response.data || { unreadCount: 0 };
}
